import api from './baseApi';
import type { UserFont } from '@/composables/fonts';
import type { SignedUrlResponse } from './typings/image';

const controller = '/Font';

export const getFonts = (): Promise<UserFont[]> =>
    api.get<UserFont[]>(`${controller}/GetFonts`).then(({ data }) => data);

export const getFontUploadSignedUrl = (filename: string): Promise<SignedUrlResponse> =>
    api
        .get<SignedUrlResponse>(`${controller}/FontUploadSignedUrl/${encodeURIComponent(filename)}`)
        .then(({ data }) => data);

export const validateFont = (filename: string): Promise<void> =>
    api.get(`${controller}/Validate/${encodeURIComponent(filename)}`).then(({ data }) => data);

export const deleteFont = (fontName: string): Promise<void> =>
    api.delete(`${controller}/${encodeURIComponent(fontName)}`).then(({ data }) => data);
